<template>
  <div class="choose-plan ma-auto text-center">
    <!-- <iconLogoPlus class="logo mt-5"></iconLogoPlus> -->
    <div class="description mt-3 mx-auto">
      {{ $t('subscription.chooseDescription') }}
    </div>
    <div class="plans mt-5">
      <div v-if="!loadingPlans">
        <v-sheet v-if="month1" @click="select(month1)" elevation="2" v-ripple rounded :class="{ selected: selectedPlanId === month1.id }" class="plan mx-auto text-left py-7 px-4 d-flex justify-space-between cursor-pointer mb-4">
          <div class="plan-name">1 {{ $tc('subscription.month', 1) }}</div>
          <div class="price d-flex align-center">
            ${{month1.unit_amount / 100}}
            <span class="ml-1">
              / {{ $tc('subscription.month') }}
            </span>
          </div>
        </v-sheet>

        <v-sheet v-if="month12" @click="select(month12)" elevation="2" v-ripple rounded :class="{ selected: selectedPlanId === month12.id }" class="popular plan mx-auto text-left py-6 px-4 d-flex justify-space-between cursor-pointer mb-4">
          <iconPopular class="flag"/>
          <div class="plan-name">
            12 {{ $tc('subscription.month', 2) }}
            <div class="total-price">
              <span class="full-price mr-2">${{month1.unit_amount * 12 / 100}}</span>
              <span>${{month12.unit_amount / 100}}</span>
            </div>
          </div>
          <div class="price d-flex align-center">
            ${{month12.unit_amount / 12 / 100}}
            <span class="ml-1">
              / {{ $tc('subscription.month') }}
            </span>
          </div>
        </v-sheet>

        <v-sheet v-if="month6" @click="select(month6)" elevation="2" v-ripple rounded :class="{ selected: selectedPlanId === month6.id }" class="plan mx-auto text-left py-4 px-4 d-flex justify-space-between cursor-pointer mb-4">
          <div class="plan-name">
            6 {{ $tc('subscription.month', 2) }}
              <div class="total-price">
                <span>${{month6.unit_amount / 100}}</span>
              </div>
            </div>
          <div class="price d-flex align-center">
            ${{month6.unit_amount / 6 / 100}}
            <span class="ml-1">
              / {{ $tc('subscription.month') }}
            </span>
          </div>
        </v-sheet>
      </div>
      <div v-else class="mb-5">
        <v-skeleton-loader
          class="mx-auto mb-5"
          max-width="350"
          type="list-item-two-line"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto mb-5"
          max-width="350"
          type="list-item-two-line"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="mx-auto mb-5"
          max-width="350"
          type="list-item-two-line"
        ></v-skeleton-loader>
      </div>

      <v-btn class="primary continue btn-text" dark @click="submit">
        {{ $t('base.continue') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
// import iconLogoPlus from '@/static/img/logo-plus.svg';
import iconPopular from '@/static/img/popular.svg';

const getPlanByName = (plans, productName) => {
  return plans.find(plan => plan.productName === productName);
};

export default {
  components: {
    // iconLogoPlus,
    iconPopular,
  },

  props: {
    selected: String,
  },

  data () {
    return {
      selectedPlanId: '',
      loadingPlans: false,
    };
  },

  computed: {
    plans () {
      return this.$store.state.user.plans;
    },

    month1 () {
      return getPlanByName(this.plans, '1 month');
    },
    month6 () {
      return getPlanByName(this.plans, '6 months');
    },
    month12 () {
      return getPlanByName(this.plans, '12 months');
    },
  },

  watch: {
    selected () {
      this.selectedPlanId = this.selected;
    },
  },

  methods: {
    select (plan) {
      this.selectedPlanId = plan.id;
    },

    submit () {
      this.$emit('selected', this.selectedPlanId);
    },
  },

  created () {
    if (!this.month12) {
      this.loadingPlans = true;
      this.$store.dispatch('user/GET_PLANS').then(() => {
        if (this.month12) {
          this.loadingPlans = false;
          this.selectedPlanId = this.month12.id;
        }
      });

      return;
    }

    this.selectedPlanId = this.selected ? this.selected : this.month12.id;
  },
};
</script>

<style lang="scss" scoped>
.continue {
  width: 300px;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  text-transform: none;
}

.logo {
  width: 313px;
}

.choose-plan {
  width: 380px;
}

.plan {
  width: 350px;
  transition: width 0.1s;

  &.selected {
    width: 100%;
    border: 2px solid #FA507B;
  }

  &.popular {
    position: relative;

    .full-price {
      font-weight: normal;
      text-decoration: line-through;
      opacity: 0.5;
    }

    .flag {
      position: absolute;
      top: -14px;
      left: -2px;
      z-index: 2;
    }

    .price,
    .plan-name {
      font-weight: 700;
    }
  }
}

.description {
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #707070;
}

.price,
.plan-name {
  font-weight: normal;
  font-size: 22px;
  line-height: 25px;
  letter-spacing: 0.222844px;
  color: #3736A0;

  span {
    font-size: 16px;
    line-height: 25px;
  }
}

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .continue {
      width: 290px;
    }

    .description {
      width: 210px
    }

    .logo {
      width: 290px;
    }

    .choose-plan {
      width: 300px;
    }

    .plan {
      width: 290px;
    }
  }
</style>
